import {
    Component,
    HostListener,
    OnInit,
    ElementRef,
    AfterContentInit,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
    AfterViewInit,
    Output,
    EventEmitter,
    OnDestroy,
    Input
} from '@angular/core';
import {filter, Subscription } from 'rxjs';

import { ScrollBarService } from './scroll-bar.service';

@Component({
    templateUrl: './scrolled-bar.component.html',
    selector: 'tk-scroll-bar',
    styleUrls: ['./scrolled-bar.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ScrolledBarComponent implements OnInit, OnDestroy {


    @Output() onScroll: EventEmitter<any> = new EventEmitter<any>();

    @Input() elementId?: string;

    public scrollTrackVisible = false;

    private isDragged = false;

    private isDraggedTop = 0;

    private isDraggedClientTop = 0;

    private options = { factor: 1 };

    public itemScrollTrackTop = 0;

    public itemScrollTrackHeight: any;

    private itemScrollTrackHeightDiff = 0;

    public itemsScrollHeight = 0;

    private deltaSub: Subscription;

    private optionsSub: Subscription;

    constructor(
        private $element: ElementRef,
        private $scrollBar: ScrollBarService
    ) {

        this.deltaSub = this.$scrollBar.getDelta().pipe(filter(delta => delta && delta.elementId === this.elementId))
          .subscribe(delta => {
            this.itemScrollTrackTop = delta.delta;
            if (this.itemScrollTrackTop < 0) {
                this.itemScrollTrackTop = 0;
            }
            if (this.itemScrollTrackTop >= this.itemsScrollHeight - this.itemScrollTrackHeight) {
                this.itemScrollTrackTop = this.itemsScrollHeight - this.itemScrollTrackHeight;
            }
        });
        this.optionsSub = this.$scrollBar.getOptions()
          .pipe(filter(options => options && options.elementId === this.elementId))
            .subscribe(options => {
                this.options = options;
                this.calculateTrackHeight();
            });

    }

    @HostListener('pointerdown', ['$event'])
    public onPointerDown(e: any) {

        if (!this.isDragged) {
            this.isDragged = true;

            let layerY = 0;
            layerY = e.layerY;
            // jak scroll tracker
            if (e.target.classList.contains('scroll-tracker')) {
                const top = parseInt((e.target.style.top || '0').replace('px', ''), 10);
                layerY = top;
            }

            // lapie pozycje klikniecia
            // jezeli klikniecie jest poza scrollem to dciagam jak moge w gore latwo w dol nie wiecej niz do krawedzi
            this.isDraggedClientTop = e.clientY;
            if (layerY <= this.itemScrollTrackTop) {
                this.itemScrollTrackTop = layerY;
            } else {
                if (layerY > this.itemScrollTrackTop + this.itemScrollTrackHeight) {
                    this.itemScrollTrackTop = layerY;
                }
            }

            // if (this.itemScrollTrackTop > this.itemsScrollHeight - this.itemScrollTrackHeight) {
            //     this.itemScrollTrackTop = this.itemsScrollHeight - this.itemScrollTrackHeight;
            // }

            const position = Math.ceil(this.itemScrollTrackTop / this.options.factor);
            this.$scrollBar.setScrollDelta({ elementId: this.elementId, position: position });

            if (e.stopPropagation) { e.stopPropagation(); }
            if (e.preventDefault) { e.preventDefault(); }
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
        }
      return false; //TODO GB - dodany return - nie wiem czy wynik jest poprawny
    }

    @HostListener('document:pointerup', ['$event'])
    public onPointerUp(e: any) {

        if (this.isDragged) {
            this.isDragged = false;

            if (e.stopPropagation) { e.stopPropagation(); }
            if (e.preventDefault) { e.preventDefault(); }
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
        }
      return false; //TODO GB - dodany return - nie wiem czy wynik jest poprawny
    }


    @HostListener('document:pointermove', ['$event'])
    public onPointerMove(e: any) {

        if (this.isDragged && e.target) {

            // klikamy przed suwakiem
            let itemScrollTrackTop = e.clientY - this.isDraggedClientTop;
            itemScrollTrackTop = (this.itemScrollTrackTop || 0) + itemScrollTrackTop;

            const itemScrollTrackHeight = this.itemScrollTrackHeight;

            if (itemScrollTrackTop < 0) {
                itemScrollTrackTop = 0;
            } else if (itemScrollTrackTop > this.itemsScrollHeight - itemScrollTrackHeight) {
                itemScrollTrackTop = this.itemsScrollHeight - itemScrollTrackHeight;
            }


            this.itemScrollTrackTop = Math.ceil(itemScrollTrackTop);
            this.isDraggedClientTop = e.clientY;


            const position = Math.ceil(
                this.itemScrollTrackTop / this.options.factor) +
                Math.ceil(this.itemScrollTrackTop * this.itemScrollTrackHeightDiff / this.itemsScrollHeight / this.options.factor);
            this.$scrollBar.setScrollDelta({ elementId: this.elementId, position: position });


            if (e.stopPropagation) { e.stopPropagation(); }
            if (e.preventDefault) { e.preventDefault(); }
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
        }
      return false; //TODO GB - dodany return - nie wiem czy wynik jest poprawny
    }

    private calculateTrackHeight() {
        this.itemsScrollHeight = (this.$element.nativeElement.offsetParent ? this.$element.nativeElement.offsetParent.clientHeight : 0);


        // top pozwala na poprawne obliczenie dlugosci tracka
        if (this.options && this.options.factor && this.itemsScrollHeight) {
            let itemScrollTrackHeight = Math.floor((this.options.factor || 1) * this.itemsScrollHeight);

            if (itemScrollTrackHeight < 25) {
                this.itemScrollTrackHeightDiff = 25 - itemScrollTrackHeight;
                itemScrollTrackHeight = 25;
            }

            this.itemScrollTrackHeight = itemScrollTrackHeight;
        }

        this.scrollTrackVisible = this.itemScrollTrackHeight < this.itemsScrollHeight;
    }


    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.deltaSub) {
            this.deltaSub.unsubscribe();
        }
        if (this.optionsSub) {
            this.optionsSub.unsubscribe();
        }
    }
}
